import React from 'react'

const ShimmerItem = () => {
  return (
    <div className='w-56 m-3 mx-7 sm:mx-3 my-6 h-80 p-3 rounded-xl border-gray-100 border-2'>
        <div className='h-40 bg-gray-200 rounded-lg'></div>
        <div className='h-6 my-3 rounded-lg bg-gray-100'></div>
        <div className='h-6 my-3 rounded-lg bg-gray-100'></div>
        <div className='h-6 my-3 rounded-lg bg-gray-100'></div>
    </div>
  )
}

export default ShimmerItem;
